import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import toast from "react-hot-toast";
import classNames from "classnames";
import { translateBackendErrorCode } from "@jti/fe-common";
import { SnpApi } from "@jti/rest-api";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { AlertBanner } from "../../../../components/AlertBanner";
import { Button } from "../../../../components/Button";
import { ConsentCheckbox } from "../../../../components/ContactForm";
import { Form, useForm } from "../../../../components/Form";
import { Recaptchabar } from "../../../../components/Recaptchabar";
import { Toaster } from "../../../../components/Toaster";
import { RichText } from "../../../../eva-components/RichText";
import { useCurrentBreakpoint } from "../../../../hooks/useCurrentBreakpoint";
import { useLocale } from "../../../../providers/useLocale";
import { EmailInput } from "./components";
import styles from "./SubscribeForm.module.scss";
export const SubscribeForm = ({ description, emailInputProps, successMessage, reCaptchaEnabled, brandingInformationEnabled, ctaLabel = "Subscribe", subTitle, title, }) => {
    const locale = useLocale();
    const [currentFormState, setCurrentFormState] = useState("clean");
    const form = useForm({
        defaultValues: {
            email: "",
            consents: {},
        },
    });
    const { formState } = form;
    const onSubmit = async () => {
        const { email, consents } = form.getValues();
        const formattedConsents = Object.entries(consents).map(([key, value]) => ({
            id: key,
            accepted: value.checked,
        }));
        try {
            const payload = {
                email,
                topics: ["marketing"],
                preferredLanguage: locale.substring(0, 2) ?? consents[formattedConsents[0]?.id]?.language,
                data_processing_agreement: formattedConsents.every((checkbox) => checkbox.accepted),
                consent_purposes: formattedConsents,
            };
            dispatchTrackingEvent(TrackingEvents.TrackingSubscribeBlockClick);
            await SnpApi.init().subscribe(payload);
            setCurrentFormState("success");
        }
        catch (e) {
            const translatedError = translateBackendErrorCode(e?.error_code);
            const [error] = e.errors || [];
            toast.error(translatedError || error || e.message);
        }
    };
    const isSuccessFullySubmitted = currentFormState === "success";
    const { mainBreakpoint } = useCurrentBreakpoint();
    const buttonSize = mainBreakpoint === "xs" ? "small" : "medium";
    return (_jsxs("div", { className: classNames(styles.subscribeFormContainer, "subscribe-form-container"), children: [_jsx(Toaster, {}), _jsx("h3", { className: styles.subscribeFormTitle, children: title }), _jsxs("div", { className: styles.textContent, children: [_jsx("h4", { className: styles.subscribeFormSubTitle, children: subTitle }), _jsx(RichText, { className: styles.subscribeFormDescription, content: description })] }), isSuccessFullySubmitted && (_jsx(AlertBanner, { title: successMessage.title, variant: "success", description: successMessage.subTitle, onClose: () => setCurrentFormState("clean") })), _jsx(Form, { form: form, onSubmit: onSubmit, children: !isSuccessFullySubmitted && (_jsxs("div", { className: styles.formContainer, children: [_jsxs("div", { className: classNames(styles.submitSection, "submit-section"), children: [_jsx("div", { className: classNames(styles.inputContainer, "input-container"), children: _jsx(EmailInput, { ...emailInputProps }) }), _jsx(Button, { size: buttonSize, disabled: !formState.isValid, isPending: formState.isSubmitting, className: classNames(styles.submitBtn, "submit-btn"), "data-testid": "subscribeFormSubmit", type: "submit", children: ctaLabel })] }), _jsx("div", { className: classNames(styles.formColumn, "form-column"), children: _jsx(ConsentCheckbox, { consent: "subscription", displayConsent: "always", namePrefix: "consents" }) }), reCaptchaEnabled && brandingInformationEnabled && (_jsx("div", { className: styles.subscribeFormRecaptcha, children: _jsx(Recaptchabar, {}) }))] })) })] }));
};
//# sourceMappingURL=SubscribeForm.js.map